module.exports = ".login-card .card-header {\n    background-color: #0CBCD4;\n}\n\n.login-card .card-body {\n    color: #373a3c;\n}\n\n.login-card .btn-primary {\n    background-color: #0CBCD4;\n}\n\n.login-card .form-spinner {\n    color: #0CBCD4;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.css
// module id = 908
// module chunks = 4